import { render, staticRenderFns } from "./AppMenuAction.vue?vue&type=template&id=aab4ce24"
import script from "./AppMenuAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenuAction.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports